import axios from "axios"
import config from "config"

//apply base url for axios
const API_URL = "" //"http://15.206.64.27:9000/api/"

const axiosApi = axios.create({
  baseURL: API_URL,
})

export const BASE = process.env.REACT_APP_BASE_URL || "";
const BASE_URL = BASE + "api/"

// Request interceptor for logging
axiosApi.interceptors.request.use(
  config => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null")
    if (authUser?.token) {
      config.headers = config.headers || {}
      config.headers.Authorization = authUser.token
    }
    console.log("[AXIOS REQUEST]", {
      url: config.url,
      method: config.method?.toUpperCase(),
      headers: { Authorization: config.headers?.Authorization ? "***" : "MISSING" },
      data: config.data
    })
    return config
  },
  error => Promise.reject(error)
)

axiosApi.interceptors.response.use(
  response => {
    console.log("[AXIOS RESPONSE]", {
      url: response.config.url,
      status: response.status,
      statusText: response.statusText,
      dataKeys: response.data ? Object.keys(response.data).slice(0, 5) : null
    })
    return response
  },
  error => {
    const url = error?.config?.url

    // 🚫 Skip redirect for OTP verification
    if (url?.includes("verifyOtp")) {
      return Promise.reject(error)
    }

    // Normal auth handling
    if (error?.response?.status === 401 && window.location.pathname !== "/login") {
      window.location.href = "/login"
    }

    return Promise.reject(error)
  }
)
// axiosApi.interceptors.response.use(
//   response => response,
//   error => Promise.reject(error)
// )
// axiosApi.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     if (
//      err.response.status >500
//     ) {
//       localStorage.removeItem("authUser")
//       window.location.assign('/login');
//       return { data: {} };
//     }
//     return Promise.reject(err);
//   },
// );
export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}

const normalizeApiError = (error, url) => {
  console.error("[API ERROR]", url, error?.response?.status, error?.response?.data || error?.message)
  const responseData = error?.response?.data
  return {
    status: 0,
    data: responseData?.data || responseData?.errors || responseData || null,
    message:
      responseData?.message ||
      responseData?.error ||
      error?.message ||
      "Unexpected server error",
    error: error?.response || error,
  }
}

const normalizeApiResponse = response => {
  // Ensure response is always a valid object with status and data
  if (!response || typeof response !== "object") {
    console.warn("[NORMALIZE] Invalid response:", response)
    return { status: 0, data: null, message: "Invalid API response", error: null }
  }
  
  // If response already has status field, return as-is
  if (response.hasOwnProperty("status")) {
    return response
  }
  
  // Otherwise wrap it in standard format
  return {
    status: response.status || 1,
    data: response.data || response,
    message: response.message || "Success",
    error: null
  }
}

// Pets APIs

// export async function getGeneralPatients(config = {}) {
//   const url = BASE_URL + "pets/v1/getPets"
//   return await axiosApi.get(url, { ...config }).then(response => response.data)
// }

export async function getGeneralPatients(vetId, config = {}) {
  const url = `${BASE_URL}pets/v1/getPets?vetId=${vetId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function getParent(data, config = {}) {
  url = BASE_URL + "patient/v1/getPatientsByDoctorId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

export async function getParentById(data, config = {}) {
  const url = BASE_URL + "patient/v1/getPatient"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

export async function getPatientById(data, config = {}) {
  const url = BASE_URL + `pets/v1/getPet/${data.petId}`
  return await axiosApi
    .get(url, { ...config })
    .then(response => response.data.data)
}

export async function getPetById(id, config = {}) {
  const url = `${BASE_URL}pets/v1/getPet/${id}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}
export async function getAllPetsByParentId(id, config = {}) {
  const url = `${BASE_URL}pets/v1/getParentPets/${id}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//Get All Parents by vetId
export async function getAllParentsByVetId(data, config = {}) {
  const url = `${BASE_URL}patient/v1/getPatientsByDoctorId`
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

//Inventory API
export async function getInventory(config = {}) {
  const url = BASE_URL + "pets/v1/getPets"
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function getInventoryById(data, config = {}) {
  const url = BASE_URL + `pets/v1/getPet/${data.petId}`
  return await axiosApi
    .get(url, { ...config })
    .then(response => response.data.data)
}

// patient/v1/getUser
export const addNewPetParent = async (
  data,
  url = BASE_URL + "patient/v1/registration",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}
// patient/v1/getUser
export const addNewPet = async (
  data,
  url = BASE_URL + "pets/v1/registration",
  config = {}
) => {
  try {
    const response = await axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data);

    return response;
  } catch (error) {
    console.error("Error in addNewPet:", error);
    return { type: "error", message: error?.response?.data?.message }
  }
}

export const updatePet = async (
  petId,
  data,
  url = BASE_URL + `pets/v1/updatePet/${petId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

export const deletePet = async (
  data,
  url = BASE_URL + "pets/v1/deletePet",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}
export const deleteParent = async (
  data,
  url = BASE_URL + "patient/v1/deletePatient",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

// export const updatePatient = async (
//   id,
//   data,
//   url = `${BASE_URL}patient/v1/userUpdate/${id}`,
//   config = {}
// ) => {
//   try {
//     return axiosApi
//       .patch(url, { ...data }, { ...config })
//       .then(response => response.data)
//   } catch (error) {
//     return { type: "error", message: error.response }
//   }
// }
export const updatePatient = async (
  parentId,
  data,
  url = BASE_URL + `patient/v1/userUpdate/${parentId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, data, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

export const fetchPets = async () => {
  const { data } = await axios.get(`${BASE_URL}pets/v1/getPets`)
  return data
}

// User API
export const checkExistance = async (data, deviceToken, config = {}) => {
  data.role = "vet"
  const url = BASE_URL + "vet/v1/loginNormalUser"
  const finalData = { ...data, deviceToken }
  return await axiosApi
    .post(url, finalData, { ...config })
    .then(response => response.data)
  // const response = await axios.post(`${BASE_URL}vet/v1/loginNormalUser`, obj)
  // return response.data
}
export const getLoggedInUserDetails = async (data, config = {}) => {
  const url = BASE_URL + "vet/v1/getUser"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(`${BASE_URL}vet/v1/getUser`, obj)
  // return response.data
}

export const googleLoginRegister = async (data, config = {}) => {
  try {
    const url = BASE_URL + "vet/v1/googleLogin"
    const response = await axiosApi.post(url, data, { ...config });
    if (response?.data) {
      return response?.data;
    }
    return response;
  } catch (error) {
    return error;
  }
  // const response = await axios.post(`${BASE_URL}vet/v1/googleLogin`, obj)
  // return response.data
}

export const sendForgotPassword = async (data, config = {}) => {
  const url = BASE_URL + "vet/v1/send-forgot-password-link"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post-password-link`,
  //   obj(
  //   `${BASE_URL}vet/v1/send-forgot
  // )
  // return response.data
}

export const updatePassword = async (data, config = {}) => {
  const url = BASE_URL + "vet/v1/updatePassword"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(`${BASE_URL}vet/v1/updatePassword`, obj)
  // return response.data
}
export const updateVet = async (
  _id,
  data,
  url = `${BASE_URL}vet/v1/userUpdate/${_id}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
  // const response = await axios.patch(`${BASE_URL}vet/v1/userUpdate/${_id}`, obj)
  // return response.data
}
export const updateVetTimings = async (
  _id,
  data,
  url = `${BASE_URL}vet/v1/userUpdateSchedule/${_id}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
  // const response = await axios.patch(
  //   `${BASE_URL}vet/v1/userUpdateSchedule/${_id}`,
  //   obj
  // )
  // return response.data
}
//Get  Timings by VetId

export async function getVetTimingsByVetId(vetId, config = {}) {
  const url = `${BASE_URL}vets/v1/getTimings/${vetId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function fetchAvailableSlots({ doctorId, date, serviceId }, config = {}) {
  const query = new URLSearchParams()
  if (doctorId) query.set("doctorId", doctorId)
  if (date) query.set("date", date)
  if (serviceId) query.set("serviceId", serviceId)
  const url = `${BASE_URL}vet/v1/appointments/available-slots?${query.toString()}`
  try {
    const response = await axiosApi.get(url, { ...config })
    return normalizeApiResponse(response.data)
  } catch (error) {
    return normalizeApiError(error, url)
  }
}

export async function rescheduleAppointment(appointmentId, data, config = {}) {
  const url = `${BASE_URL}vet/v1/appointments/${appointmentId}/reschedule`

  try {
    const response = await axiosApi.patch(url, { ...data }, { ...config })
    return normalizeApiResponse(response.data)
  } catch (error) {
    return normalizeApiError(error, url)
  }
}
export const registerVet = async (data, deviceToken, config = {}) => {
  console.log(data, "datattt")
  const url = BASE_URL + "vet/v1/registration"
  const finalData = { ...data, deviceToken }
  return await axiosApi
    .post(url, finalData, { ...config })
    .then(response => response.data)
  // const response = await axios.post(`${BASE_URL}vet/v1/registration`, obj)
  // return response.data
}
export const uploadAttachment = async (formData, config = {}) => {
  const response = await axiosApi.post(
    `${BASE_URL}vet/v1/uploadImages`,
    formData,
    config
  )
  return response.data
}

// Appointments

export const fetchAppointments = async (config = {}) => {
  const url = BASE_URL + `Appointment/v1/todayAppointment`
  try {
    const response = await axiosApi.get(url, { ...config })
    return normalizeApiResponse(response.data)
  } catch (error) {
    return normalizeApiError(error, url)
  }
}

export const fetchAppointmentsBasedOnDoctorId = async (id, virtual = false, config = {}) => {
  let url = `${BASE_URL}Appointment/v1/doctorTodayAppointment/${id}`
  if (virtual) {
    url = `${url}?appointmentType=virtual`
  }

  try {
    const response = await axiosApi.get(url, { ...config })
    return normalizeApiResponse(response.data)
  } catch (error) {
    return normalizeApiError(error, url)
  }
}

export const fetchAppointmentsForDateRange = async (doctorId, startDate, endDate, config = {}) => {
  const params = new URLSearchParams({ doctorId, startDate, endDate, status: "open" })
  const url = `${BASE_URL}vet/v1/appointments/dashboard-card?${params.toString()}`
  try {
    const response = await axiosApi.get(url, { ...config })
    return normalizeApiResponse(response.data)
  } catch (error) {
    return normalizeApiError(error, url)
  }
}

export const fetchAppointmentsBasedOnId = async (id, config = {}) => {
  const url = `${BASE_URL}Appointment/v1/getAppointment`
  try {
    const response = await axiosApi.post(url, { appointmentId: id }, { ...config })
    return normalizeApiResponse(response.data)
  } catch (error) {
    return normalizeApiError(error, url)
  }
}

// The backend must authorize both the appointment and attachment before issuing a URL.
export const fetchAppointmentAttachmentUrl = async (appointmentId, attachmentId) => {
  const url = `${BASE_URL}Appointment/v1/${encodeURIComponent(appointmentId)}/attachment/${encodeURIComponent(attachmentId)}`
  const response = await axiosApi.get(url)
  return response.data?.data?.url || response.data?.data?.signedUrl || response.data?.url || response.data?.signedUrl
}
  // const response = await axios.post(
  //   `${BASE_URL}Appointment/v1/getAppointment`,
  //   { appointmentId: id },...config
  // )
  // return response.data

// Globals
export const getServiceType = async (config = {}) => {
  const url = BASE_URL + `ServiceList/v1/getServiceList`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
  // const response = await axios.get(`${BASE_URL}ServiceList/v1/getServiceList`)
  // return response.data
}
export const getPetTypes = async (config = {}) => {
  const url = BASE_URL + `PetTypes/v1/getPetTypes`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
  // const response = await axios.get(`${BASE_URL}PetTypes/v1/getPetTypes`)
  // return response.data
}
export const getPetBreed = async (id, config = {}) => {
  const url = BASE_URL + `Breeds/v1/getBreedsById/${id}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
  // const response = await axios.get(`${BASE_URL}Breeds/v1/getBreedsById/${id}`)
  // return response.data
}
// Globals
export const updateVisit = async (
  id,
  data,
  url = `${BASE_URL}Appointment/v1/updateVisit/${id}`,
  config = {}
) => {
  try {
    const response = await axiosApi.patch(url, { ...data }, { ...config });
    return response?.data;
  } catch (error) {
    console.error("Error in updateVisit:", error);
    return error?.response?.data;
  }
  // const response = await axios.patch(
  //   `${BASE_URL}Appointment/v1/updateVisit/${id}`,
  //   obj
  // )
  // return response.data
}
export const updatePrescription = async (
  id,
  data,
  url = `${BASE_URL}Appointment/v1/updatePrescription/${id}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
  // const response = await axios.patch(
  //   `${BASE_URL}Appointment/v1/updatePrescription/${id}`,
  //   obj
  // )
  // return response.data
}
export const updateImaging = async (
  id,
  data,
  url = `${BASE_URL}Appointment/v1/addImaging/${id}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
  // const response = await axios.patch(
  //   `${BASE_URL}Appointment/v1/addImaging/${id}`,
  //   obj
  // )
  // return response.data
}

export const addAppointment = async (data, config = {}) => {
  const url = `${BASE_URL}Appointment/v1/createAppointment`

  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

export const updateAppointment = async (
  id,
  data,
  url = `${BASE_URL}Appointment/v1/editAppointment/${id}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
  // const response = await axios.patch(
  //   `${BASE_URL}Appointment/v1/editAppointment/${id}`,
  //   obj
  // )
  // return response.data
}

export const updateAppointmentConsultationMode = async (
  appointmentId,
  mode,
  config = {}
) => {
  const url = `${BASE_URL}Appointment/v1/${appointmentId}/consultation-mode`
  return await axiosApi
    .patch(url, { mode }, { ...config })
    .then(response => response.data)
}

export const deleteAppointment = async (id, config = {}) => {
  const url = `${BASE_URL}Appointment/v1/deleteAppointment/`

  return await axiosApi
    .post(url, { appointmentId: id }, { ...config })
    .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}Appointment/v1/deleteAppointment/`,
  //   {
  //     appointmentId: id,
  //   }
  // )
  // return response.data
}
export const getDiagnosisList = async (id, config = {}) => {
  const url = BASE_URL + `Diagnosis/v1/getDiagnosis`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
  // const response = await axios.get(`${BASE_URL}Diagnosis/v1/getDiagnosis`)
  // return response.data
}
export const getMedicineList = async (id, config = {}) => {
  const url = BASE_URL + `MedicineMaster/v1/getMedicineMaster`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
  // const response = await axios.get(
  //   `${BASE_URL}MedicineMaster/v1/getMedicineMaster`
  // )
  // return response.data
}

export const fetchAppointmentsListBasedOnPetId = async (id, config = {}) => {
  const url = BASE_URL + `Appointment/v1/getAppointmentsByPetId/${id}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
  // const response = await axios.get(
  //   `${BASE_URL}Appointment/v1/getAppointmentsByPetId/${id}`
  //   // { appointmentId: id }
  // )
  // return response.data
}

// Timings
export const fetchTimings = async (id, data, config = {}) => {
  const url = `${BASE_URL}vets/v1/timings/${id}`
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

export const updateDayAvailabilityByDayIdAndDocId = async (
  data,
  config = {}
) => {
  const url = BASE_URL + "vets/v1/updateDayAvailabilityByDayIdAndDocId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}vets/v1/updateDayAvailabilityByDayIdAndDocId`,
  //   data
  // )
  // return response.data
}

export const updateStartAndEndTimeByDayIdAndDocId = async (
  data,
  config = {}
) => {
  const url = BASE_URL + "vets/v1/updateStartAndEndTimeByDayIdAndDocId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}vets/v1/updateStartAndEndTimeByDayIdAndDocId`,
  //   data
  // )
  // return response.data
}
//Update start and end time for a particular day
export const updateStartAndEndTimeByDayIdAndDocIdForParticularDay = async (
  data,
  config = {}
) => {
  const url =
    BASE_URL +
    `vets/v1/updateOneDayStartAndEndTimeByDayIdAndDocId/${data.doctorId}`
  try {
    const response = await axiosApi.post(url, data, { ...config })
    console.log("response.datainsideapi????", response)

    return response.data
  } catch (error) {
    throw error
  }
  // return await axiosApi
  //   .post(url, data, { ...config })
  //   .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}vets/v1/updateStartAndEndTimeByDayIdAndDocId`,
  //   data
  // )
  // return response.data
}
// Dynamic provider availability. Slot calculation remains a backend concern.
const getAvailabilityUrl = (providerType, providerId) =>
  `${BASE_URL}availability/v1/${providerType}/${providerId}`

export const fetchProviderAvailability = async (
  providerType,
  providerId,
  config = {}
) => {
  const url = getAvailabilityUrl(providerType, providerId)
  return axiosApi.get(url, { ...config }).then(response => response.data)
}

export const updateProviderDefaultTiming = async (
  providerType,
  providerId,
  data,
  config = {}
) => {
  const url = `${getAvailabilityUrl(providerType, providerId)}/default`
  return axiosApi.put(url, data, { ...config }).then(response => response.data)
}

export const updateProviderSlotDuration = async (
  providerType,
  providerId,
  slotDuration,
  config = {}
) => {
  const url = `${getAvailabilityUrl(providerType, providerId)}/slot-duration`
  return axiosApi
    .put(url, { slotDuration }, { ...config })
    .then(response => response.data)
}

export const saveProviderParticularDay = async (
  providerType,
  providerId,
  data,
  config = {}
) => {
  const url = `${getAvailabilityUrl(providerType, providerId)}/particular-day`
  return axiosApi.post(url, data, { ...config }).then(response => response.data)
}

export const deleteProviderParticularDay = async (
  providerType,
  providerId,
  date,
  config = {}
) => {
  const url = `${getAvailabilityUrl(
    providerType,
    providerId
  )}/particular-day/${encodeURIComponent(date)}`
  return axiosApi.delete(url, { ...config }).then(response => response.data)
}

export const addProviderHoliday = async (
  providerType,
  providerId,
  date,
  config = {}
) => {
  const url = `${getAvailabilityUrl(providerType, providerId)}/holiday`
  return axiosApi
    .post(url, { date }, { ...config })
    .then(response => response.data)
}

export const deleteProviderHoliday = async (
  providerType,
  providerId,
  date,
  config = {}
) => {
  const url = `${getAvailabilityUrl(
    providerType,
    providerId
  )}/holiday/${encodeURIComponent(date)}`
  return axiosApi.delete(url, { ...config }).then(response => response.data)
}

// imaging and Labs

export const addImagingRequest = async (data, config = {}) => {
  const url = BASE_URL + "ImagingAndLab/v1/createImagingAndLab"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}ImagingAndLab/v1/createImagingAndLab`,
  //   data
  // )
  // return response.data
}
export const updateImagingRequest = async (data, config = {}) => {
  const url = BASE_URL + "ImagingAndLab/v1/updateImagingAndLab"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}ImagingAndLab/v1/updateImagingAndLab`,
  //   data
  // )
  // return response.data
}

export const getImagingAndLap = async (data, config = {}) => {
  const url = BASE_URL + "ImagingAndLab/v1/getImagingAndLabsByDoctorIdAndType"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // const response = await axios.post(
  //   `${BASE_URL}ImagingAndLab/v1/getImagingAndLabsByDoctorIdAndType`,
  //   data
  // )
  // return response.data
}

export const getImagingAndLabsBasedOnId = async (data, config = {}) => {
  // Based on Test id
  const url = BASE_URL + "ImagingAndLab/v1/getImagingAndLabsBasedOnId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}
// const response = await axios.post(
//   `${BASE_URL}ImagingAndLab/v1/getImagingAndLabsBasedOnId`,
//   data
// )
// return response.data
// }

export const getImagingAndLabsBasedOnPetId = async (data, config = {}) => {
  const url =
    BASE_URL + "ImagingAndLab/v1/getCompletedImagingAndLabsBasedOnPetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
  // Based on Test id
  // const response = await axios.post(
  //   `${BASE_URL}ImagingAndLab/v1/getCompletedImagingAndLabsBasedOnPetId`,
  //   data
  // )
  // return response.data
}
export const getAllVetSpecialization = async (id, config = {}) => {
  const url = `${BASE_URL}VeterinarySpecialties/v1/getAllVetSpecialization`
  return await axiosApi.get(url, { ...config }).then(response => response.data)

  // const response = await axios.get(
  //   `${BASE_URL}VeterinarySpecialties/v1/getAllVetSpecialization`
  // )
  // return response.data
}

//Pricing Category API methods

//fetch Pricing Ctegories
export async function getPricingCategoryByVetId(data, config = {}) {
  const url = BASE_URL + "PriceCategories/v1/getAllPriceCategoriesByVetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// Creating new Pricing Categories
export const addNewPricingCategory = async (
  data,
  url = BASE_URL + "PriceCategories/v1/createPriceCategories",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Update Category name
export const updateCategory = async (
  categoryId,
  data,
  url = BASE_URL + `PriceCategories/v1/PriceCategoriesUpdate/${categoryId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Delete Category
export const deleteCategory = async (
  categoryId,
  url = BASE_URL + `PriceCategories/v1/deletePriceCategories/${categoryId}`,
  config = {}
) => {
  try {
    console.log("categoryId,", categoryId)

    return axiosApi
      .delete(url, { ...config }) // Spread the 'config' object, not 'data'
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Get PricingCategory details by Id

export async function getPricingCategoryById(itemId, config = {}) {
  const url = `${BASE_URL}PriceCategories/v1/getPriceCategoriesById/${itemId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//Pricng API Methods

//Fetching the price of a particular Category

export async function getAllPricingByVetIdAndCategoryId(data, config = {}) {
  const url = BASE_URL + "Pricing/v1/getAllPricingByVetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// Creating new Pricing
export const createpricing = async (
  data,
  url = BASE_URL + "Pricing/v1/createPricing",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Updating the Pricing Details
export const updatepricing = async (
  pricingItemId,
  data,
  url = BASE_URL + `Pricing/v1/PricingUpdate/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Deleting pricing
export const deletePricing = async (
  pricingItemId,
  url = BASE_URL + `Pricing/v1/deletePricing/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .delete(url, { ...config }) // Spread the 'config' object, not 'data'
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Get Pricing Item details by Id

export async function getPricingItemById(itemId, config = {}) {
  const url = `${BASE_URL}Pricing/v1/getPricingById/${itemId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//Generic Pricing API Methods

//Get All  Categories of Type Generic by VetId

export async function getGenericCategoryByVetId(vetId, config = {}) {
  const url = `${BASE_URL}PriceCategories/v1/getAllGenericPricingCategories/${vetId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//Inventory API Methods

//fetch All Inventory Items by vetId
export async function getInventoryitemsByVetId(data, config = {}) {
  const url = BASE_URL + "Inventory/v1/getAllInventoryByVetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// Creating new Inventory Item
export const createInventoryItem = async (
  data,
  url = BASE_URL + "Inventory/v1/createInventory",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Updating the Inventory item Details
export const updateInventoryitem = async (
  pricingItemId,
  data,
  url = BASE_URL + `Inventory/v1/InventoryUpdate/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Deleting the Inventory item
export const deleteInventoryItem = async (
  pricingItemId,
  url = BASE_URL + `Inventory/v1/deleteInventory/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .delete(url, { ...config }) // Spread the 'config' object, not 'data'
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Get the Inventory item Details by Id

export async function getinventoryItemById(itemId, config = {}) {
  const url = `${BASE_URL}Inventory/v1/getInventoryById/${itemId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//  Manufacturer API Methods

//fetch All Manufacturer by vetId
export async function getManufacturersByVetId(data, config = {}) {
  const url = BASE_URL + "Manufactures/v1/getAllManufacturesByVetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// Creating new Manufacturer
export const createManufacturer = async (
  data,
  url = BASE_URL + "Manufactures/v1/createManufactures",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Updating the Manufacturer Details
export const updateManufacturer = async (
  manufacturerId,
  data,
  url = BASE_URL + `Manufactures/v1/ManufacturesUpdate/${manufacturerId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Deleting the Manufacturer
export const deleteManufacturer = async (
  pricingItemId,
  url = BASE_URL + `Manufactures/v1/deleteManufacture/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .delete(url, { ...config }) // Spread the 'config' object, not 'data'
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Get the Manufacturer Details by Id

export async function getManufacturerById(itemId, config = {}) {
  const url = `${BASE_URL}Manufactures/v1/getManufactureById/${itemId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//  Aisle API Methods

//fetch All Aisle by vetId
export async function getAislesByVetId(data, config = {}) {
  const url = BASE_URL + "AisleLocations/v1/getAllAisleLocationsByVetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// Creating new Aisle
export const createAisle = async (
  data,
  url = BASE_URL + "AisleLocations/v1/createAisleLocations",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Updating the Aisle Details
export const updateAisle = async (
  aisleId,
  data,
  url = BASE_URL + `AisleLocations/v1/AisleLocationsUpdate/${aisleId}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Deleting the Aisle
export const deleteAisle = async (
  pricingItemId,
  url = BASE_URL + `AisleLocations/v1/deleteAisleLocation/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .delete(url, { ...config }) // Spread the 'config' object, not 'data'
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Get the Aisle Details by Id

export async function getAisleById(itemId, config = {}) {
  const url = `${BASE_URL}AisleLocations/v1/getAisleLocationById/${itemId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//  Inventory Type API Methods

//fetch All Inventory Type by vetId
export async function getInventoryTypeByVetId(data, config = {}) {
  const url = BASE_URL + "Types/v1/getAllTypesByVetId"
  return await axiosApi
    .post(url, data, { ...config })
    .then(response => response.data)
}

// Creating new Inventory Type
export const createInventoryType = async (
  data,
  url = BASE_URL + "Types/v1/createTypes",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Updating the Aisle Details
// export const updateInventoryType = async (
//   pricingItemId,
//   data,
//   url = BASE_URL + `Manufactures/v1/ManufacturesUpdate/${pricingItemId}`,
//   config = {}
// ) => {
//   try {
//     return axiosApi
//       .patch(url, { ...data }, { ...config })
//       .then(response => response.data)
//   } catch (error) {
//     return { type: "error", message: error.response }
//   }
// }

export const updateInventoryType = async (
  id,
  data,
  url = BASE_URL + `Types/v1/TypesUpdate/${id}`,
  config = {}
) => {
  try {
    return axiosApi
      .patch(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return {
      type: "error",
      message: error.response?.data?.message || "Something went wrong",
    }
  }
}

//Deleting the Inventory Type
export const deleteInventoryType = async (
  pricingItemId,
  url = BASE_URL + `Types/v1/deleteTypes/${pricingItemId}`,
  config = {}
) => {
  try {
    return axiosApi
      .delete(url, { ...config }) // Spread the 'config' object, not 'data'
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Get the Inventory Type Details by Id

export async function getInventoryTypeById(itemId, config = {}) {
  const url = `${BASE_URL}Types/v1/getTypesById/${itemId}`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//Dashboard API Methods
// Fetch Weekly Revenue from vetId
export const fetchWeeklyRevenueByVetId = async (
  data,
  url = BASE_URL + "Appointment/v1/weeklyClinicRevenue",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

// Fetch Weekly Revenue from vetId
export const fetchWeeklyPatientCountByVetId = async (
  data,
  url = BASE_URL + "Appointment/v1/weeklyClinicPatientRevnue",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

// Fetch Weekly Revenue from vetId
export const fetchYearlyRevenueByVetId = async (
  data,
  url = BASE_URL + "Appointment/v1/yearlyClinicRevenue",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//Address master Data

// fetch all countries
export async function getCountries(config = {}) {
  const url = `${BASE_URL}WorldMasterData/v1/getAllMasterCountries`
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

//fetch all state based on the country
export const fetchAllStateBasedOnCountry = async (
  data,
  url = BASE_URL + "WorldMasterData/v1/getAllMasterStatesBasedCountries",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

//fetch all cities based on the country
export const fetchAllCityBasedOnCountry = async (
  data,
  url = BASE_URL + "WorldMasterData/v1/getAllMasterCitiesBasedState",
  config = {}
) => {
  try {
    return axiosApi
      .post(url, { ...data }, { ...config })
      .then(response => response.data)
  } catch (error) {
    return { type: "error", message: error.response }
  }
}


export const fetchDashboardApi = async (params) => {
  try {
    console.log("[DASHBOARD API] Raw params:", params)
    const cleanParams = {}

    if (params?.doctorId) cleanParams.doctorId = params.doctorId
    if (params?.vetId) cleanParams.vetId = params.vetId
    if (params?.startDate) cleanParams.startDate = params.startDate
    if (params?.endDate) cleanParams.endDate = params.endDate
    if (params?.status) cleanParams.status = params.status
    if (params?.appointmentStatus) cleanParams.appointmentStatus = params.appointmentStatus
    if (params?.petType) cleanParams.petType = params.petType

    console.log("[DASHBOARD API] Cleaned params:", cleanParams)
    console.log("[DASHBOARD API] Full URL:", `${BASE_URL}vet/v1/dashboard`)
    
    const response = await axiosApi.post(`${BASE_URL}vet/v1/dashboard`, cleanParams)
    
    console.log("[DASHBOARD API] Response status:", response?.status)
    console.log("[DASHBOARD API] Response data:", response?.data)
    
    const normalized = normalizeApiResponse(response.data)
    if (normalized?.data?.dashboardResponse && !normalized?.data?.appointments) {
      normalized.data = {
        ...normalized.data,
        ...normalized.data.dashboardResponse,
        appointments:
          normalized.data.dashboardResponse.appointments ||
          normalized.data.dashboardResponse.data?.appointments ||
          normalized.data.appointments ||
          [],
      }
    }
    console.log("[DASHBOARD API] Normalized response:", normalized)
    return normalized
  } catch (error) {
    console.error("[DASHBOARD API] Full error object:", {
      message: error?.message,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      data: error?.response?.data,
      headers: error?.response?.headers,
      config: error?.config?.url,
    })
    return normalizeApiError(error, `${BASE_URL}vet/v1/dashboard`)
  }
}

export const fetchDashboardApiTwo = async (petType, doctorId, start, end) => {
  try {
    const url = `${BASE_URL}vet/v1/analytics?petType=${encodeURIComponent(petType)}&doctorId=${encodeURIComponent(doctorId)}&end=${encodeURIComponent(end)}&start=${encodeURIComponent(start)}`
    console.log("[DASHBOARD API TWO] Sending request:", { petType, doctorId, start, end })
    const response = await axiosApi.get(url)
    console.log("[DASHBOARD API TWO] Response received:", response)
    const normalized = normalizeApiResponse(response.data)
    console.log("[DASHBOARD API TWO] Normalized response:", normalized)
    return normalized
  } catch (error) {
    console.error("[DASHBOARD API TWO] Request failed:", error)
    return normalizeApiError(error, `${BASE_URL}vet/v1/analytics`)
  }
}

export const sendEmailOTP = async ({ email, userId, role }) => {
  try {
    const response = await axiosApi.post(`${BASE_URL}vet/v1/sendOtpForMailVerify`, { email, userId, role });
    return response.data
  } catch (error) {
    return { type: "error", message: error.response }
  }
}

export async function verifyEmailOTP(params) {
  try {
    const { email, otp, userId } = params;
    const response = await axiosApi.post(`${BASE_URL}vet/v1/verifyEmailOtp`, { email, otp, userId });
    return response.data
  } catch (error) {
    console.error("Error in verifyEmailOTP:", error);
    return { type: "error", message: error.response }
  }
}

export async function sendMobileVerificationOTP(params) {
  try {
    const { countryCode, phone, userId } = params;
    const response = await axiosApi.post(`${BASE_URL}vet/v1/Verify-mobile-for-exiting-user`, { countryCode, phone, userId });
    return response.data
  } catch (error) {
    return { type: "error", message: error.response }
  }
}


export async function verifyMobileOTP(params) {
  try {
    const { countryCode, phone, otp, userId } = params;
    const response = await axiosApi.post(`${BASE_URL}vet/v1/verifyOtp`, { countryCode, phone, otp, userId });
    return response.data
  } catch (error) {
    console.error("Error in verifyEmailOTP:", error);
     return {
      status: 0,
      message:
        error?.response?.data?.message || "Invalid OTP",
    };
  }
}

export async function updateAppointmentPaymentStatus(params) {
  try {
    const { id, paymentDone } = params;
    const response = await axiosApi.patch(`${BASE_URL}Appointment/v1/update-payment-status/${id}`, { paymentDone });
    return response.data
  } catch (error) {
    console.error("Error in verifyEmailOTP:", error);
    return { type: "error", message: error.response }
  }
}


export async function CancelAppointment(params) {
  try {
    const { id } = params;
    const response = await axiosApi.post(`${BASE_URL}Appointment/v1/cancelAppointment`, { appointmentId: id });
    return response.data
  } catch (error) {
    console.error("Error in CancelAppointment:", error);
    return { type: "error", message: error.response }
  }
}
export async function sendBirthdayWish(data) {
  try {
    const response = await axiosApi.post(`${BASE_URL}Appointment/v1/sendBirthdayWish`, data);
    return response.data;
  } catch (error) {
    console.error("Error in sendBirthdayWish:", error);
    return { type: "error", message: error.response };
  }
}

export const getPetColours = async () => {
  const response = await get("/api/PetColours/v1/getPetColours")
  return response?.data ?? response?.data?.data ?? response ?? []
}
